<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <page-heading heading="Запросы подчиненных на оценку 360"></page-heading>
    <el-card>
      <requests-component></requests-component>
    </el-card>
  </div>
</template>

<script>
import RequestsComponent from "@/modules/evaluation/components/request/RequestsComponent.vue";
import PageHeading from "@/components/PageHeading";

export default {
  name: 'eval-requests',
  components: {
    RequestsComponent,
    PageHeading,
  },
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>